import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import SaveHandlerSelectionFormContainer from '../containers/SaveHandlerSelectionFormContainer';
import Modal from '../../../../core/modules/common/components/Modal';

class SaveHandlerSelectionModal extends Component {
  onSubmitSaveSelection = ({ name }) => {
    this.props.saveSelection({
      name,
      checkedHandlers: this.props.checkedHandlers,
    });
  };

  render() {
    return (
      <Modal
        header={
          <FormattedMessage
            id="app.save.handler.selection.form.title"
            tagName="h3"
          />
        }
        closeOnOutsideClick
        onClose={this.props.closeModal}
      >
        <SaveHandlerSelectionFormContainer
          onSubmit={this.onSubmitSaveSelection}
          onCloseModal={this.props.closeModal}
          selections={this.props.selections}
          handlers={this.props.handlers}
        />
      </Modal>
    );
  }
}

SaveHandlerSelectionModal.propTypes = {
  selections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    handlers: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  checkedHandlers: PropTypes.arrayOf(PropTypes.string).isRequired,
  saveSelection: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  handlers: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default (SaveHandlerSelectionModal);
